export const filterConfig = [
  {
    id: 'NumeroNF',
    type: 'text',
    label: 'Numero NF',
    placeholder: 'Digite o numero da NF'
  },
  {
    id: 'SerieNF',
    type: 'text',
    label: 'Serie NF',
    placeholder: 'Digite a serie da NF'
  },
  {
    id: 'TipoNota',
    type: 'select',
    label: 'Tipo Nota',
    placeholder: 'Selecione...',
    options: [
      { value: '1', label: 'Normal' },
      { value: '2', label: 'Devolucao' }
    ]
  },
  {
    id: 'DescricaoDevolucao',
    type: 'text',
    label: 'Descricao Devolucao',
    placeholder: 'Digite a descricao da devolucao'
  },
  {
    id: 'MotivoDevolucao',
    type: 'select',
    label: 'Motivo Devolucao',
    placeholder: 'Selecione...',
    options: [
      { value: '1', label: 'Erro Cliente' },
      { value: '2', label: 'Erro Operador Logistico' },
      { value: '3', label: 'Outros' }
    ]
  },
  {
    id: 'CNPJCliente',
    type: 'text',
    label: 'CNPJ Cliente',
    placeholder: 'Digite o CNPJ do cliente'
  },
  {
    id: 'NomeCliente',
    type: 'text',
    label: 'Nome Cliente',
    placeholder: 'Digite o nome do cliente'
  },
  // {
  //   id: 'TipoOperacao',
  //   type: 'text',
  //   label: 'Tipo Operacao',
  //   placeholder: 'Digite o tipo de operacao'
  // },
  // {
  //   id: 'NomeDestinatario',
  //   type: 'text',
  //   label: 'Nome Destinatario',
  //   placeholder: 'Digite o destinatario'
  // },
  // {
  //   id: 'NomeRemetente',
  //   type: 'text',
  //   label: 'Nome Remetente',
  //   placeholder: 'Digite o remetente'
  // },
  // {
  //   id: 'NomeUsuarioLeitura',
  //   type: 'text',
  //   label: 'Usuario Leitura',
  //   placeholder: 'Digite o usuario de leitura'
  // },
  // {
  //   id: 'NomeResponsavelComercial',
  //   type: 'text',
  //   label: 'Responsavel Comercial',
  //   placeholder: 'Digite o responsavel comercial'
  // },
  // {
  //   id: 'NomeResponsavelLancamento',
  //   type: 'text',
  //   label: 'Responsavel Lancamento',
  //   placeholder: 'Digite o responsavel lancamento'
  // },
  // {
  //   id: 'NomeResponsavelFechamento',
  //   type: 'text',
  //   label: 'Responsavel Fechamento',
  //   placeholder: 'Digite o responsavel fechamento'
  // },
  // {
  //   id: 'ProtocoloPedidoTMSPaletizacao',
  //   type: 'text',
  //   label: 'Protocolo Paletizacao',
  //   placeholder: 'Digite o protocolo do TMS'
  // },
  // {
  //   id: 'ProtocoloPedidoTMSEtiquetagem',
  //   type: 'text',
  //   label: 'Protocolo Etiquetagem',
  //   placeholder: 'Digite o protocolo do TMS'
  // },
  {
    id: 'NumeroPedidoTMS',
    type: 'text',
    label: 'Numero Pedido Cobrança',
    placeholder: 'Digite o numero do pedido de cobranca'
  },
  {
    id: 'NumeroCarga',
    type: 'text',
    label: 'Numero Carga',
    placeholder: 'Digite o numero da carga'
  },
  {
    id: 'NumeroPedido',
    type: 'text',
    label: 'Numero Pedido',
    placeholder: 'Digite o numero do pedido'
  },
  {
    id: 'PlacaVeiculo',
    type: 'text',
    label: 'Placa Veiculo',
    placeholder: 'Digite a placa do veiculo'
  },
  {
    id: 'NumeroFrota',
    type: 'text',
    label: 'Numero Frota',
    placeholder: 'Digite o numero da frota'
  },
  {
    id: 'DescricaoModeloVeicular',
    type: 'text',
    label: 'Modelo Veicular',
    placeholder: 'Digite o modelo veicular'
  },
  {
    id: 'InfoMotorista',
    type: 'text',
    label: 'Info Motorista',
    placeholder: 'Digite informacoes do motorista'
  },
  {
    id: 'ModelosReboque',
    type: 'text',
    label: 'Modelos Reboque',
    placeholder: 'Digite os modelos de reboque'
  },
  {
    id: 'FrotasReboque',
    type: 'text',
    label: 'Frotas Reboque',
    placeholder: 'Digite as frotas de reboque'
  },
  {
    id: 'PlacasReboque',
    type: 'text',
    label: 'Placas Reboque',
    placeholder: 'Digite as placas de reboque'
  },
  {
    id: 'DescricaoSituacaoDigitalizacaoCanhoto',
    type: 'select',
    label: 'Situacao Digitalizacao Canhoto',
    placeholder: 'Selecione...',
    options: [
      { value: '', label: 'Selecione..' },
      { value: 'Digitalizado', label: 'Digitalizado' },
      { value: 'Pendente', label: 'Pendente' }
    ]
  },
  {
    id: 'DataAgendamentoPedidoInicio',
    type: 'date',
    label: 'Data Agendamento Pedido (Inicio)'
  },
  {
    id: 'DataAgendamentoPedidoFim',
    type: 'date',
    label: 'Data Agendamento Pedido (Fim)'
  },
  {
    id: 'Observacoes',
    type: 'text',
    label: 'Observacoes',
    placeholder: 'Digite observacoes'
  },
  // {
  //   id: 'NomeUsuarioEnvioCanhoto',
  //   type: 'text',
  //   label: 'Usuario Canhoto',
  //   placeholder: 'Digite o usuario do envio'
  // },
  {
    id: 'DescricaoDivergencia',
    type: 'text',
    label: 'Descricao Divergencia',
    placeholder: 'Digite a divergencia'
  },
  {
    id: 'DataChegadaInicio',
    type: 'date',
    label: 'Data Chegada (Inicio)'
  },
  {
    id: 'DataChegadaFim',
    type: 'date',
    label: 'Data Chegada (Fim)'
  },
  // {
  //   id: 'DataLeituraInicio',
  //   type: 'date',
  //   label: 'Data Leitura (Inicio)'
  // },
  // {
  //   id: 'DataLeituraFim',
  //   type: 'date',
  //   label: 'Data Leitura (Fim)'
  // },
  // {
  //   id: 'DataConferenciaInicio',
  //   type: 'date',
  //   label: 'Data Conferencia (Inicio)'
  // },
  // {
  //   id: 'DataConferenciaFim',
  //   type: 'date',
  //   label: 'Data Conferencia (Fim)'
  // },
  // {
  //   id: 'DataArmazenagemInicio',
  //   type: 'date',
  //   label: 'Data Armazenagem (Inicio)'
  // },
  // {
  //   id: 'DataArmazenagemFim',
  //   type: 'date',
  //   label: 'Data Armazenagem (Fim)'
  // },
  {
    id: 'DataAgendamentoInicio',
    type: 'date',
    label: 'Data Agendamento (Inicio)'
  },
  {
    id: 'DataAgendamentoFim',
    type: 'date',
    label: 'Data Agendamento (Fim)'
  },
  {
    id: 'DataSaidaInicio',
    type: 'date',
    label: 'Data Saida/Entrega (Inicio)'
  },
  {
    id: 'DataSaidaFim',
    type: 'date',
    label: 'Data Saida/Entrega (Fim)'
  },
  // {
  //   id: 'DataEnvioCanhotoInicio',
  //   type: 'date',
  //   label: 'Data Envio Canhoto (Inicio)'
  // },
  // {
  //   id: 'DataEnvioCanhotoFim',
  //   type: 'date',
  //   label: 'Data Envio Canhoto (Fim)'
  // },
  // {
  //   id: 'MudancaTabelaPrecoManual',
  //   type: 'select',
  //   label: 'Mudanca Tabela Preco',
  //   placeholder: 'Selecione...',
  //   options: [
  //     { value: 'true', label: 'Sim' },
  //     { value: 'false', label: 'Nao' }
  //   ]
  // },
  // {
  //   id: 'CobrancaPaletizacaoRealizada',
  //   type: 'select',
  //   label: 'Cobranca Paletizacao',
  //   placeholder: 'Selecione...',
  //   options: [
  //     { value: 'true', label: 'Sim' },
  //     { value: 'false', label: 'Nao' }
  //   ]
  // },
  // {
  //   id: 'CobrancaEtiquetagemRealizada',
  //   type: 'select',
  //   label: 'Cobranca Etiquetagem',
  //   placeholder: 'Selecione...',
  //   options: [
  //     { value: 'true', label: 'Sim' },
  //     { value: 'false', label: 'Nao' }
  //   ]
  // },
  // {
  //   id: 'CobrancaArmazenagemRealizada',
  //   type: 'select',
  //   label: 'Cobranca Armazenagem',
  //   placeholder: 'Selecione...',
  //   options: [
  //     { value: 'true', label: 'Sim' },
  //     { value: 'false', label: 'Nao' }
  //   ]
  // },
  // {
  //   id: 'CobrancaArmazenagemPendente',
  //   type: 'select',
  //   label: 'Cobranca Armazenagem Pendente',
  //   placeholder: 'Selecione...',
  //   options: [
  //     { value: 'true', label: 'Sim' },
  //     { value: 'false', label: 'Nao' }
  //   ]
  // },
  {
    id: 'ExisteDivergencia',
    type: 'select',
    label: 'Existe Divergencia',
    placeholder: 'Selecione...',
    options: [
      { value: 'true', label: 'Sim' },
      { value: 'false', label: 'Nao' }
    ]
  },
  {
    id: 'Finalizado',
    type: 'select',
    label: 'Finalizado',
    placeholder: 'Selecione...',
    options: [
      { value: 'true', label: 'Sim' },
      { value: 'false', label: 'Nao' }
    ]
  },
  {
    id: 'PendenteEntrega',
    type: 'select',
    label: 'Data Saida (Pendente)',
    placeholder: 'Selecione...',
    options: [
      { value: 'true', label: 'Sim' },
      { value: 'false', label: 'Nao' }
    ]
  },
  {
    id: 'AgendamentoPendente',
    type: 'select',
    label: 'Data Agendamento (Pendente)',
    placeholder: 'Selecione...',
    options: [
      { value: 'true', label: 'Sim' },
      { value: 'false', label: 'Nao' }
    ]
  },
  // {
  //   id: 'CanhotoEnviado',
  //   type: 'select',
  //   label: 'Canhoto Enviado',
  //   placeholder: 'Selecione...',
  //   options: [
  //     { value: 'true', label: 'Sim' },
  //     { value: 'false', label: 'Nao' }
  //   ]
  // },
  // {
  //   id: 'PendenteFinalizacao',
  //   type: 'select',
  //   label: 'Pendente Finalizacao',
  //   placeholder: 'Selecione...',
  //   options: [
  //     { value: 'true', label: 'Sim' },
  //     { value: 'false', label: 'Nao' }
  //   ]
  // },
  {
    id: 'OrdenarPor',
    type: 'select',
    label: 'Ordenar por',
    placeholder: 'Selecione...',
    options: [
      { value: 'DataChegada', label: 'Data Chegada' },
      // { value: 'DataLeitura', label: 'Data Leitura' },
      // { value: 'DataConferencia', label: 'Data Conferencia' },
      { value: 'DataArmazenagem', label: 'Data Armazenagem' },
      { value: 'DataAgendamento', label: 'Data Agendamento' },
      { value: 'DataSaida', label: 'Data Saida' }
      // { value: 'DataEnvioCanhoto', label: 'Data Envio Canhoto' }
    ]
  },
  {
    id: 'Direcao',
    type: 'select',
    label: 'Direcao',
    placeholder: 'Selecione...',
    options: [
      { value: 'asc', label: 'Asc' },
      { value: 'desc', label: 'Desc' }
    ]
  }
];
